<script setup>
import { useBatchStore } from '@/stores/BatchStore'

const emit = defineEmits(['editInSettings'])

const batchStore = useBatchStore()

const handleEditInSettings = () => {
  emit('editInSettings')
}
</script>
<template>
  <div class="base-tooltip-light py-[10px] px-3 shadow-sm rounded-lg mt-5 flex flex-col gap-y-3 w-[324px] prevent-click-outside">
    <div class="flex justify-between items-center">
      <span class="text-gray-900 text-sm font-medium">Set Locked</span>
      <div class="flex items-center gap-x-2 cursor-pointer prevent-click-outside">
        <Icon icon="heroicons:cog-8-tooth" class="text-tint-1 w-4 h-4" />
        <span class="text-tint-1 text-xs font-medium" @click="handleEditInSettings">Edit in Settings</span>
      </div>
    </div>
    <template v-if="batchStore.selectedBatch?.locked_sets?.length">
      <div v-for="lockedSet in batchStore.selectedBatch?.locked_sets" :key="lockedSet.id">
        <span class="text-gray-400 text-xs font-medium">{{ lockedSet.collx_set_name }}</span>
      </div>
    </template>
    <template v-else-if="batchStore.selectedBatch?.lock_id ">
      <div>
        <span class="text-gray-400 text-xs font-medium">{{ batchStore.selectedBatch?.lock_name }}</span>
      </div>
    </template>
  </div>
</template>